export const contacts = {
list: {
  count_other: "{{count}} contacts",
  count_many: "{{count}} contacts",
  count_one: "{{count}} contact",
  csv: {
    scope: "Visible par",
    organisation: "Société",
    phone: "Téléphone",
    email: "E-mail",
    roles: "Rôles",
    displayName: "Nom affiché",
  },
  insight: {
    signalOrgs_other: "{{count}} organisations ont des informations manquantes.",
    signalOrgs_many: "{{count}} organisations ont des informations manquantes.",
    signalOrgs_one: "{{count}} organisation a des informations manquantes.",
    signalSkills_other: "{{count}} prestataires n'ont aucune compétence renseignée.",
    signalSkills_many: "{{count}} prestataires n'ont aucune compétence renseignée.",
    signalSkills_one: "{{count}} prestataire n'a aucune compétence renseignée.",
    signalVisible_other: "{{count}} contacts correspondent à cette vue.",
    signalVisible_many: "{{count}} contacts correspondent à cette vue.",
    signalVisible_one: "{{count}} contact correspond à cette vue.",
    summaryMissing_other: "{{count}} contacts n'ont ni e-mail ni numéro de téléphone.",
    summaryMissing_many: "{{count}} contacts n'ont ni e-mail ni numéro de téléphone.",
    summaryMissing_one: "{{count}} contact n'a ni e-mail ni numéro de téléphone.",
    source: "les contacts que vous pouvez voir",
    metricSkillGaps: "Sans compétences",
    metricMissingReach: "Sans e-mail ni téléphone",
    metricVisible: "Affichés",
    signalOrgsOk: "Aucune organisation n'a d'informations manquantes.",
    signalSkillsOk: "Les prestataires affichés ont des compétences renseignées.",
    summaryOk: "Tous les contacts affichés ont un e-mail ou un numéro de téléphone.",
    actionOrgs: "Complétez les fiches des organisations avant d'exporter ou de produire des rapports.",
    actionSkills: "Ajoutez les compétences des prestataires pour que le meilleur soit suggéré pour chaque intervention.",
    actionReach: "Ajoutez un e-mail ou un numéro de téléphone aux contacts à qui vous confiez du travail.",
  },
  historySummary: "Travaux liés, notes et liens d'annuaire",
  untitledJob: "Intervention sans titre",
  noLinkedSkills: "Aucune compétence pour l'instant",
  noRolesAssigned: "Aucun rôle pour l'instant",
  independentContact: "Contact indépendant",
  kindInternal: "Interne",
  noSkillMatches: "Aucune compétence ne correspond.",
  searchSkills: "Rechercher des compétences…",
  showingA11y: "Affichage : {{role}}. Modifier le filtre",
  roleAll: "Tous",
  noContacts: "Aucun contact",
  purpose: "Personnes externes : prestataires, fournisseurs et clients",
  showMeHow: "Montrez-moi comment",
  clearFilters: "Effacer les filtres",
  addContractor: "Ajouter un prestataire",
title: "Contacts",
addContact: "Ajouter un contact",
loading: "Chargement…",
emptyFilteredTitle: "Aucun contact correspondant",
loadFailedTitle: "Nous n'avons pas pu charger vos contacts",
loadUnavailableTitle: "Les contacts sont indisponibles",
emptyTitle: "Pas encore de contacts",
emptyFilteredSubtitle: "Aucun contact ne correspond à ces filtres. Touchez Effacer les filtres pour tout voir.",
emptyContractorsTitle: "Aucun prestataire pour l’instant",
emptyContractorsSubtitle: "Ajoutez un prestataire pour lui confier des interventions ou lui demander des devis.",
visibilityGroupA11y: "Qui peut les voir",
visibilityChip: {
  all: "Tous",
  team: "Équipe uniquement",
  account: "Tout l'espace de travail",
},
emptySubtitle: "Ajoutez les personnes et les entreprises avec qui vous travaillez. Les prestataires ajoutés peuvent recevoir des interventions et des demandes de devis.",
importLabel: "Importer",
},
shared: {
kindLabel: "Type de contact",
kind: {
person: "Personne",
organisation: "Organisation",
},
visibility: {
team: "Mon équipe uniquement",
account: "Tout le monde dans mon entreprise",
},
role: {
contractor: "Prestataire",
landlord: "Propriétaire bailleur",
owner: "Propriétaire",
client: "Client",
agent_broker: "Agent / courtier",
tenant: "Locataire",
supplier: "Fournisseur",
inspector: "Inspecteur",
occupant: "Occupant",
driver: "Conducteur",
fleet_manager: "Gestionnaire de flotte",
operator: "Opérateur",
engineer: "Ingénieur",
technician: "Technicien",
other: "Autre",
},
roleGroup: {
general: "Général",
property: "Immobilier",
fleet: "Flotte",
equipment: "Équipement",
},
roleDescription: {
contractor: "Peut recevoir du travail, des demandes de devis et des mises à jour d'intervention.",
landlord: "Représente le propriétaire du bien ou le groupe propriétaire.",
owner: "Détient l'actif ou le portefeuille auquel ce contact est lié.",
client: "Demande du travail, examine les constats ou approuve les réparations.",
agent_broker: "Agit pour le compte du propriétaire, du client ou du locataire.",
tenant: "Occupe ou utilise l'actif et peut signaler des problèmes.",
supplier: "Fournit des matériaux, des pièces ou des services spécialisés.",
inspector: "Réalise des inspections, examens ou contrôles de conformité.",
occupant: "Habite, utilise ou est affecté à l'actif.",
driver: "Conduit ou est affecté à un véhicule de la flotte.",
fleet_manager: "Gère les véhicules, conducteurs et opérations de flotte.",
operator: "Exploite ou est affecté à un équipement.",
engineer: "Entretient, révise ou répare l'équipement.",
technician: "Entretien, tests ou réparations pratiques sur l'équipement.",
other: "À utiliser si aucun autre rôle ne convient.",
},
primaryToggle: {
primary: "Principal",
makePrimary: "Définir comme principal",
},
phoneType: {
mobile: "Portable",
work: "Travail",
home: "Domicile",
other: "Autre",
},
},
create: {
  contractorEmailHint: "Les prestataires ont besoin d'un e-mail : les interventions et les demandes de devis y sont envoyées.",
  headerSubtitleContractor: "Une personne extérieure à votre équipe à qui confier des interventions ou demander des devis.",
  headerTitleContractor: "Nouveau prestataire",
  visibilityEveryone: "Tout le monde dans votre entreprise peut voir ce contact.",
headerTitle: "Nouveau contact",
headerSubtitle: "Ajoutez une personne ou une organisation à l'annuaire de votre compte.",
unnamedFallback: "Contact sans nom",
roleSummary: "{{role}} - {{description}}",
a11y: {
person: "Le contact est une personne",
organisation: "Le contact est une organisation",
},
alerts: {
  contractorEmailRequired: "Ajoutez son e-mail pour qu'il reçoive les interventions et les demandes de devis.",
  contractorEmailTitle: "Ajoutez son e-mail",
  createFailedTitle: "Impossible d'ajouter le contact",
required: "Saisissez un nom, un e-mail ou un numéro de téléphone.",
noAccountTitle: "Compte indisponible",
noAccountBody: "Rejoignez ou créez un compte avant d'ajouter des contacts.",
createFailed: "Impossible d'ajouter ce contact. Réessayez dans un instant.",
emailNeededTitle: "E-mail requis pour partager",
emailNeededBody: "Ajoutez une adresse e-mail valide : c’est ainsi que ce contact reçoit l’actif partagé.",
invalidPhoneTitle: "Vérifiez le numéro de téléphone",
invalidPhoneBody: "Saisissez un numéro valide pour le pays sélectionné, ou laissez le téléphone vide.",
},
sections: {
basicIdentityTitle: "Identité de base",
basicIdentityHelper: "Qui est ce contact et comment il doit apparaître dans votre annuaire.",
contactInfoTitle: "Coordonnées",
contactInfoHelper: "Comment votre équipe peut le contacter.",
whoIsThisTitle: "Qui est-ce ?",
whoIsThisHelper: "Choisissez si vous ajoutez une personne ou une organisation.",
contactMethodTitle: "Comment le contacter ?",
contactMethodHelper: "Ajoutez la meilleure adresse e-mail et le meilleur numéro de téléphone pour le suivi.",
rolesWideTitle: "Rôles et types",
rolesWideHelper: "Sélectionnez tous les rôles applicables à ce contact.",
visibilityWideTitle: "Visibilité",
visibilityWideHelper: "Choisissez qui peut voir et utiliser ce contact.",
rolesTitle: "Rôles",
rolesHelper: "Sélectionnez tous les rôles applicables à ce contact.",
visibilityTitle: "Visibilité",
visibilityHelper: "Choisissez qui peut voir et utiliser ce contact.",
detailsWideTitle: "Détails supplémentaires",
skillsTitle: "Compétences",
skillsHelper: "Les compétences déterminent à quelles interventions ce contact peut être affecté et qui est suggéré pour celles-ci.",
detailsTitle: "Détails supplémentaires",
detailsHelper: "Détails commerciaux facultatifs.",
},
labels: {
displayName: "Nom d'affichage",
organisation: "Nom de l'organisation",
organisations: "Organisations",
company: "Société",
email: "E-mail",
phone: "Téléphone",
companyRegistrationNumber: "Numéro d'immatriculation de la société",
vatTaxNumber: "Numéro de TVA / fiscal",
notes: "Notes",
skills: "Compétences",
},
placeholders: {
displayName: "ex. Alex Inspecteur",
organisation: "ex. Northside Property Group",
company: "ex. Northside Services",
companyShort: "Nom de société facultatif",
email: "name@example.com",
phone: "Meilleur numéro de contact",
companyRegistrationNumber: "Numéro d'immatriculation (facultatif)",
vatTaxNumber: "Numéro de TVA ou fiscal (facultatif)",
notes: "Notes privées",
},
visibility: {
team: "Mon équipe uniquement",
account: "Tout le monde dans mon entreprise",
},
skillsPicker: {
title: "Compétences du contact",
hint: "Choisissez des compétences dans le catalogue de votre compte. Elles apparaissent sur le contact et dans les filtres.",
},
actions: {
saving: "Enregistrement...",
submit: "Ajouter le contact",
submitContractor: "Ajouter le prestataire",
dictate: "Dicter",
stopDictation: "Arrêter",
},
title: "Ajouter un contact",
addedAs: "Ajouté en tant que",
nameLabel: "Nom",
namePlaceholder: "Nom complet",
emailLabel: "E-mail",
saveAndUse: "Ajouter et utiliser un contact",
quickCreate: {
  duplicateReason: {
    name: "Même nom",
    phone: "Même numéro de téléphone",
    email: "Même adresse e-mail",
  },
closeA11y: "Fermer ajouter un contact",
requiredToShareSuffix: " · requis pour partager",
reviewPossibleMatch: "Examiner la correspondance possible",
discardTitle: "Abandonner ce contact ?",
discardBody: "Vous avez saisi des coordonnées qui n'ont pas encore été enregistrées.",
keepEditing: "Continuer à modifier",
discard: "Abandonner",
duplicateHeading: "Contact existant possible",
duplicateHint: "Réutiliser une identité existante lorsqu'il s'agit de la même personne. La création d'un enregistrement distinct ne fusionne jamais automatiquement les données.",
useExisting: "Utiliser l'existant",
useExistingA11y: "Utiliser le contact existant {{name}}",
createSeparate: "Créer un contact distinct",
createSeparateA11y: "Créer un contact distinct après la vérification des doublons",
},
},
card: {
noDetails: "Aucune coordonnée",
invitedNotJoined: "Invité · n'a pas encore rejoint",
email: "E-mail",
call: "Appeler",
emailA11y: "Envoyer un e-mail à {{name}}",
callA11y: "Appeler {{name}}",
roles: "Rôles",
skills: "Compétences",
none: "Aucun",
unlink: "Délier {{name}}",
accessChange: "Accès : {{label}}. Modifier",
access: {
requester: "Peut demander",
viewer: "Peut consulter",
none: "Aucun accès",
},
},
shareEdit: {
sendInvite: "Envoyer l’invitation",
resendInvite: "Renvoyer l’invitation",
sending: "Envoi…",
removeAccess: "Retirer l’accès",
},
detail: {
  inviterFallback: "Une personne avec qui vous travaillez",
  noRolesYet: "Aucun rôle pour l'instant. Touchez Modifier et choisissez Prestataire pour lui confier des interventions.",
  inviteNeedsEmail: "Ajoutez une adresse e-mail pour inviter {{name}}.",
  resendFailed: "Impossible de renvoyer l'invitation. Réessayez dans un instant.",
title: "Contact",
loadingMessage: "Chargement des coordonnées...",
noContactSelected: "Aucun contact sélectionné",
contactNotFound: "Contact introuvable",
loadFailedTitle: "Nous n'avons pas pu charger ce contact",
loadUnavailableTitle: "Ce contact ne peut pas être affiché",
goBack: "Retour",
scopeTeamOnly: "Mon équipe uniquement",
sectionOverview: "Vue d’ensemble",
sectionRoles: "Rôles",
sectionContactDetails: "Coordonnées",
sectionInvitations: "Invitations et accès",
sectionVisibility: "Visibilité",
sectionTeamAccess: "Accès de l'équipe",
sectionSkills: "Compétences",
sectionHistory: "Historique",
labelType: "Type",
labelName: "Nom",
labelOrganisation: "Organisation",
labelCompany: "Société",
labelCompanyRegistrationNumber: "Numéro d'immatriculation de la société",
labelVatTaxNumber: "Numéro de TVA / fiscal",
labelStatus: "Statut",
labelEmail: "E-mail",
labelPhone: "Téléphone",
labelAudience: "Public",
labelOwningTeam: "Équipe propriétaire",
statusArchived: "Archivé",
statusActive: "Actif",
noEmailOrPhone: "Pas d'e-mail ni de téléphone",
visibleToAllTeams: "Tout le monde dans votre entreprise peut voir ce contact.",
noSkillsAssigned: "Aucune compétence attribuée. Modifiez le contact pour ajouter des balises de votre catalogue de compétences.",
joinedApp: "Ce contact a rejoint l'application",
pendingInvites: "Invitation(s) en attente — ils peuvent utiliser le lien pour se connecter",
noInvitesYet: "Aucune invitation pour l’instant",
inviteSent: "Envoyée {{date}}",
inviteExpires: "Expire {{date}}",
inviteStatus: {
pending: "en attente",
accepted: "acceptée",
revoked: "révoquée",
expired: "expirée",
},
resend: "Renvoyer",
revoke: "Révoquer",
revokeInviteTitle: "Révoquer l'invitation",
revokeInviteMessage: "Cela annulera l'invitation.",
cancel: "Annuler",
edit: "Modifier",
editContactA11y: "Modifier le contact",
contactAlreadyInApp: "Contact déjà dans l'application",
inviteContactToAppA11y: "Inviter un contact à l'application",
alreadyInApp: "Déjà dans l'application",
inviteToApp: "Inviter dans l'application",
invite: "Inviter",
share: "Partager",
shareWithTeam: "Partager avec l'équipe",
shareContactWithTeamA11y: "Partager le contact avec l'équipe",
shareContactWithAnotherTeamA11y: "Partager le contact avec une autre équipe",
promote: "Partager avec toutes les équipes",
promoteToAccount: "Partager avec toutes les équipes",
promoteContactToAccountA11y: "Partager ce contact avec toutes les équipes",
promoteContactVisibilityA11y: "Partager ce contact avec toutes les équipes",
archiveContact: "Archiver le contact",
archive: "Archiver",
backToContactsListA11y: "Retour à la liste de contacts",
contactsBreadcrumb: "Contacts",
noOtherTeamsTitle: "Aucune autre équipe",
noOtherTeamsBody: "Il n’existe aucune autre équipe avec laquelle partager ce contact.",
sharedTitle: "Partagé",
sharedBody: "Contact partagé avec {{team}}.",
fallbackTeam: "équipe",
errorTitle: "Cela n'a pas fonctionné",
failedToShare: "Impossible de partager le contact. Réessayez dans un instant.",
promoteToAccountBody: "Tout le monde dans votre entreprise pourra voir ce contact.",
doneTitle: "Terminé",
promotedBody: "Tout le monde dans votre entreprise peut désormais voir ce contact.",
failedToPromote: "Impossible de partager le contact avec toutes les équipes. Réessayez dans un instant.",
invitationSentTitle: "Invitation envoyée",
invitationSentBody: "Un e-mail a été envoyé à {{email}}.",
invitationCreatedTitle: "Invitation enregistrée, e-mail non envoyé",
invitationCreatedBody: "Nous avons enregistré l'invitation pour {{email}} mais n'avons pas pu l'envoyer par e-mail. Touchez Renvoyer pour réessayer.",
failedToCreateInvite: "Impossible de créer l'invitation. Réessayez dans un instant.",
archiveContactTitle: "Archiver le contact",
archiveContactBody: "Ce contact sera masqué des listes. Vous pouvez restaurer plus tard si nécessaire.",
failedToArchive: "Impossible d'archiver le contact. Réessayez dans un instant.",
invitesEmailResent: "Envoyé",
invitesEmailResentBody: "E-mail d'invitation renvoyé.",
inviteLinkUpdatedTitle: "E-mail non envoyé",
inviteLinkUpdatedBody: "Impossible d'envoyer l'invitation par e-mail. Touchez Renvoyer pour réessayer dans un instant.",
timelineLoadingTitle: "Chargement de l'activité du contact",
timelineErrorTitle: "L'activité est incomplète",
timelineEmptyTitle: "Aucune activité pour le moment",
timelineLoadingSubtitle: "Récupération du travail et de l'historique liés.",
timelineErrorSubtitle: "Certains enregistrements liés n'ont pas pu être chargés. Réessayez le travail lié ci-dessus.",
timelineEmptySubtitle: "Les partages, demandes, inspections, interventions et invitations impliquant {{name}} apparaîtront ici.",
accessLevel: {
view: "Voir",
edit: "Modifier",
manage: "Gérer",
},
},
edit: {
pageTitle: "Modifier le contact",
noContactId: "Aucun identifiant de contact",
contactNotFound: "Contact introuvable",
back: "Retour",
kindA11yPerson: "Type de contact : personne",
kindA11yOrganisation: "Type de contact : organisation",
basicIdentityHelperWide: "Personne ou organisation. Le nom d’affichage (ou le prénom et le nom) est requis.",
displayNameLabel: "Nom d'affichage *",
displayNamePlaceholder: "Nom affiché dans les listes",
displayNameA11yWide: "Nom d’affichage, obligatoire",
displayNameA11yNarrow: "Nom d’affichage (obligatoire)",
firstNameLabel: "Prénom",
firstNamePlaceholder: "Prénom",
lastNameLabel: "Nom",
lastNamePlaceholder: "Nom",
organisationsLabel: "Organisations",
contactInfoHelper: "Utilisé pour les invitations et le suivi.",
emailLabel: "E-mail",
emailPlaceholder: "email@example.com",
emailA11yWide: "Adresse e-mail",
phoneLabel: "Téléphone",
whoIsThisHelperNarrow: "Personne ou organisation. Le nom est requis ; l’organisation aide avec le contexte.",
contactMethodHelperNarrow: "L'e-mail ou le téléphone vous aide à les joindre plus tard.",
rolesTitleWide: "Rôles et types",
rolesTitleNarrow: "Que sont-ils pour nous ?",
rolesHelper: "Choisissez un ou plusieurs rôles pour que ce contact apparaisse dans les bons flux.",
visibilityHelperWide: "Mon équipe uniquement : seule votre équipe voit ce contact. Tout le monde dans mon entreprise : toutes les équipes le voient.",
visibilityTitleNarrow: "Qui peut utiliser ce contact ?",
visibilityHelperNarrow: "Seule votre équipe le voit, sauf si vous choisissez Tout le monde dans mon entreprise. Vous pourrez le partager avec toutes les équipes plus tard.",
visibilityA11yTeam: "Visibilité : mon équipe uniquement",
visibilityA11yAccount: "Visibilité : tout le monde dans mon entreprise",
vatA11y: "Numéro de TVA ou de taxe",
notesTitleWide: "Notes",
notesTitleNarrow: "Détails facultatifs",
notesHelper: "Les notes sont réservées à votre équipe.",
improving: "Amélioration...",
improveWithAi: "Améliorer avec l'IA",
addNotesFirstTitle: "Ajouter des notes en premier",
addNotesFirstBody: "Tapez ou dictez un court brouillon, puis utilisez Améliorer avec l'IA.",
unableToImproveNotesTitle: "Impossible d'améliorer les notes",
improveNotesFailed: "Impossible d'améliorer les notes. Veuillez réessayer.",
tidiedNotesTitle: "Notes remises au propre",
tidiedNotesRationale: "Vérifiez les notes remises au propre avant de les appliquer.",
saveChanges: "Enregistrer les modifications",
saving: "Enregistrement…",
requiredTitle: "Obligatoire",
requiredNameBody: "Saisissez un nom : nom d'affichage ou nom et prénom, ou nom de l'organisation.",
workspaceChangedError: "Votre espace de travail a changé. Rouvrez le contact avant de continuer.",
updateFailed: "Impossible d'enregistrer vos modifications. Réessayez dans un instant.",
},
import: {
  actions: {
    addManually: "Ajouter manuellement",
    phonePicker: "Sélecteur du téléphone",
    uploadFile: "Importer un fichier",
  },
  access: {
    whyLine: "AssetWRX lit vos contacts uniquement pour vous laisser choisir qui ajouter.",
    deniedTitle: "L'accès aux contacts est désactivé",
    deniedBody: "Autorisez l'accès pour voir ici les contacts de votre téléphone. Vous pouvez toujours ajouter des personnes manuellement ou avec le sélecteur du téléphone.",
    allow: "Autoriser l'accès",
    openSettings: "Ouvrir les réglages",
    limited: "Vous n'avez partagé que certains contacts avec AssetWRX. Utilisez le sélecteur du téléphone pour ajouter les autres.",
    unavailableTitle: "Les contacts de votre téléphone ne sont pas disponibles ici",
    unavailableBody: "L'import depuis les contacts fonctionne dans l'application iOS et Android. Ici, vous pouvez ajouter des personnes manuellement ou importer un fichier.",
  },
  list: {
    searchA11y: "Rechercher des contacts",
    searchPlaceholder: "Rechercher un nom, une entreprise, un e-mail ou un numéro",
    count_one: "{{count}} contact sur ce téléphone",
    count_many: "{{count}} contacts sur ce téléphone",
    count_other: "{{count}} contacts sur ce téléphone",
    loading: "Chargement de vos contacts…",
    emptyTitle: "Aucun contact sur ce téléphone",
    emptyBody: "Ajoutez des personnes manuellement, ou utilisez le sélecteur du téléphone si vos contacts sont dans une autre application.",
    noMatchTitle: "Personne ne correspond à « {{query}} »",
    noMatchBody: "Vérifiez l'orthographe, ou cherchez par entreprise, e-mail ou numéro.",
    alreadyAdded: "Déjà dans AssetWRX",
    reviewA11y: "Vérifier {{name}} avant de l'ajouter",
    selectA11y: "Sélectionner {{name}}",
    selectAll: "Tout sélectionner ({{total}})",
    clearSelection: "Effacer la sélection",
    import: "Importer",
    importCount_one: "Importer {{count}}",
    importCount_many: "Importer {{count}}",
    importCount_other: "Importer {{count}}",
  },
  confirm: {
    title_one: "Ajouter {{count}} contact",
    title_many: "Ajouter {{count}} contacts",
    title_other: "Ajouter {{count}} contacts",
    subtitle: "Depuis les contacts de votre téléphone",
    alreadyNote_one: "{{count}} est déjà dans AssetWRX et sera ajouté à nouveau.",
    alreadyNote_many: "{{count}} sont déjà dans AssetWRX et seront ajoutés à nouveau.",
    alreadyNote_other: "{{count}} sont déjà dans AssetWRX et seront ajoutés à nouveau.",
    roleLabel: "Rôle",
    roleHelper: "Facultatif. S'applique à toutes les personnes ajoutées, et peut être modifié plus tard.",
    visibilityLabel: "Qui peut les voir",
    privacy: "Ajoutez uniquement les personnes avec qui vous travaillez. Elles seront visibles par {{audience}}.",
    audienceTeam: "votre équipe",
    audienceAccount: "toute votre entreprise",
    cancel: "Annuler",
    confirm_one: "Ajouter {{count}}",
    confirm_many: "Ajouter {{count}}",
    confirm_other: "Ajouter {{count}}",
    progress: "Ajout de {{done}} sur {{total}}…",
    closeA11y: "Fermer",
  },
  notes: {
    jobTitle: "Fonction : {{value}}",
    otherEmails: "Autres e-mails : {{value}}",
  },
  alerts: {
    readFailedTitle: "Impossible de lire les contacts",
    readFailedDefaultBody: "Réessayez, ou utilisez le sélecteur du téléphone pour ajouter les personnes une par une.",
    pickerFailedTitle: "Impossible d'ouvrir le sélecteur de contact",
    pickerFailedDefaultBody: "Accordez l’accès aux contacts dans Paramètres et réessayez.",
    invalidContactTitle: "Contact invalide",
    invalidContactBody: "Ce contact n'a aucune information utilisable. Veuillez en sélectionner un autre.",
    noAccountTitle: "Pas de compte",
    noAccountBody: "Vous devez être dans un compte pour ajouter des contacts.",
    stoppedTitle: "Importation arrêtée",
    stoppedWithProgress: "Ajout de {{count}} avant une erreur : {{error}}",
    unknownError: "Erreur inconnue",
    completeBody_one: "{{count}} contact ajouté.",
    completeBody_other: "{{count}} contacts ajoutés.",
    completeBody_many: "{{count}} contacts ajoutés.",
  },
  review: {
    requiredTitle: "Obligatoire",
    requiredBody: "Entrez un nom.",
    errorTitle: "Erreur",
    errorDefaultBody: "Échec de la création du contact.",
    noContactSelected: "Aucun contact sélectionné. Revenez en arrière et choisissez-en un sur votre téléphone.",
    backToContacts: "Retour aux contacts",
    nameSectionTitle: "Nom *",
    nameA11y: "Nom (obligatoire)",
    namePlaceholder: "Nom affiché",
    companyA11y: "Société (facultatif)",
    companyPlaceholder: "Société (facultatif)",
    notesA11y: "Notes (facultatif)",
    notesPlaceholder: "Notes privées (facultatif)",
    visibilitySectionTitle: "Qui peut utiliser ce contact ?",
    skillsSectionTitle: "Compétences",
    skillsPickerHint: "Facultatif : attachez des compétences de catalogue à ce contact importé.",
    nameLabel: "Nom",
    companyLabel: "Entreprise",
    notesLabel: "Remarques",
    rolesSectionTitle: "Rôle",
    moreDetails: "Plus de détails",
    fewerDetails: "Moins de détails",
    extraPhones_one: "Ajoute aussi {{count}} autre numéro : {{numbers}}",
    extraPhones_many: "Ajoute aussi {{count}} autres numéros : {{numbers}}",
    extraPhones_other: "Ajoute aussi {{count}} autres numéros : {{numbers}}",
    existingTitle: "Déjà dans AssetWRX sous le nom {{name}}",
    existingOpen: "Ouvrir",
    save: "Enregistrer",
    saveAndAnother: "Enregistrer et en ajouter un autre",
    addedToast: "{{name}} ajouté",
  },
},
picker: {
  createNamed: "Créer « {{search}} »",
defaultTitle: "Sélectionner le contact",
closeA11y: "Fermer le sélecteur de contacts",
searchPlaceholder: "Rechercher un nom, une entreprise, une adresse e-mail ou un rôle...",
searchA11y: "Rechercher des contacts",
scope: {
all: "Tous",
team: "Équipe uniquement",
account: "Tout l'espace de travail",
},
sections: {
recommended: "Recommandé pour ce travail",
recent: "Récent",
searchResults: "Résultats de recherche",
allContacts: "Tous les contacts",
},
searching: "Recherche…",
empty: {
  noMatch: "Personne ne s'appelle « {{search}} » pour l'instant.",
  noneNoCreate: "Aucun contact pour l'instant.",
  none: "Aucun contact pour l'instant. Touchez {{label}}.",
skillsScoped: "Aucun contact {{scope}} ne correspond à ces compétences. Affichez tous les contacts ou désactivez un filtre de compétences.",
searchScoped: "Aucun contact {{scope}} ne correspond à votre recherche. Affichez tous les contacts ou essayez un autre nom.",
idleScoped: "Aucun contact n'est encore partagé avec {{scope}}. Affichez tous les contacts ou ajoutez-en un.",
skills: "Aucun contact ne correspond à ces compétences. Désactivez un filtre de compétences ou effectuez une recherche par nom.",
search: "Aucun contact ne correspond.",
idle: "Tapez pour rechercher des contacts.",
},
showAllContacts: "Afficher tous les contacts",
clearScopeA11y: "Effacez le filtre {{scope}} et affichez tous les contacts",
deselectA11y: "Désélectionner {{name}}",
selectA11y: "Sélectionnez {{name}}",
selectWithRolesA11y: "Sélectionnez {{name}}, rôles {{roles}}",
recommendedReason: "Recommandé · {{reason}}",
workspaceWide: "Tout le monde",
teamOnly: "Mon équipe uniquement",
skillsLabel: "Compétences",
clear: "Effacer",
clearSkillFiltersA11y: "Effacer les filtres de compétences",
addFilter: "Ajouter un filtre",
hide: "Masquer",
hideSkillListA11y: "Masquer la liste des filtres de compétences",
addSkillFiltersA11y: "Ajouter des filtres de compétences",
skillFilterHint: "Facultatif : filtrer les contacts par une ou plusieurs compétences.",
removeSkillFilterA11y: "Supprimer le filtre {{skill}}",
fromThisJob: "De cette intervention",
filterBySkillA11y: "Filtrer par {{skill}}",
searchSkillsPlaceholder: "Rechercher des compétences...",
searchSkillsA11y: "Rechercher des compétences",
noSkillsMatch: "Aucune compétence ne correspond à votre recherche.",
addAction: "Ajouter",
removeAction: "Supprimer",
toggleSkillFilterA11y: "{{action}} le filtre {{skill}}",
selectedCount_one: "{{count}} sélectionné",
selectedCount_many: "{{count}} sélectionnés",
selectedCount_other: "{{count}} sélectionnés",
continueLabel: "Continuer",
continueWithA11y: "Continuer avec {{count}} {{noun}}",
contactNoun_one: "contact",
contactNoun_other: "contacts",
contactNoun_many: "contacts",
},
organisationsField: {
empty: "Aucune organisation liée pour l'instant.",
chooseOrganisation: "Choisir l'organisation",
primaryA11y: "Organisation principale",
removeA11y: "Supprimer l'organisation",
titlePlaceholder: "Titre (par ex. responsable de la fiabilité)",
titleA11y: "Titre dans l'organisation",
addA11y: "Ajouter une organisation",
addLabel: "Ajouter une organisation",
pickerTitle: "Sélectionnez une organisation",
},
phonesField: {
empty: "Pas de numéro de téléphone pour l'instant.",
phoneTypeA11y: "Type de téléphone {{label}}",
primaryA11y: "Téléphone principal",
removeA11y: "Supprimer le téléphone",
addA11y: "Ajouter un numéro de téléphone",
addLabel: "Ajouter un téléphone",
},
threeSixty: {
assetSharedTitle: "{{asset}} partagé avec {{name}}",
shareSubtitle: "Partage · {{status}}",
requestSubtitle: "Demande · {{status}}",
jobFallback: "Intervention",
inspectionLabel: "Inspection",
contactJoinedTitle: "{{name}} a rejoint l'application",
invitedTitle: "Invité dans l'application ({{email}})",
invitationSubtitle: "Invitation · {{status}}",
appStandingInApp: "Dans l'application",
appStandingPending: "Invitation en attente depuis {{when}}",
appStandingNotInvited: "Pas encore invité",
statusActive: "Actif",
lastActivity: "Dernière activité {{when}}",
noActivityYet: "Aucune activité pour l'instant",
noEmailOrPhone: "Aucun e-mail ou téléphone au dossier.",
emailA11y: "E-mail {{email}}",
callA11y: "Appeler {{phone}}",
openWork: {
sharedAssets: "Actifs partagés",
openRequests: "Demandes ouvertes",
openInspections: "Inspections ouvertes",
openJobs: "Interventions ouvertes",
},
openWorkInfo: {
sharedAssetsDesc: "Actifs que ce contact peut voir et sur lesquels il peut émettre des demandes via un partage actif.",
sharedAssetsBasedOn: "{{active}} partages sur {{total}} toujours actifs, comptés en direct",
openRequestsDesc: "Demandes provenant de ou pour ce contact qui n'ont pas été fermées, refusées ou converties.",
openRequestsBasedOn: "{{open}} demandes sur {{total}} toujours ouvertes, comptées en direct",
openInspectionsDesc: "Inspections liées à ce contact qui n'ont pas été complétées.",
openInspectionsBasedOn: "{{open}} inspections liées sur {{total}}, comptées en direct",
openJobsDesc: "Interventions inachevées explicitement liées à ce contact. Le travail attribué uniquement via leur compte utilisateur peut ne pas apparaître ici.",
openJobsBasedOn: "{{open}} interventions liées sur {{total}}, comptées en direct",
},
loadingLinkedWork: "Chargement du travail lié",
linkedWorkErrorTitle: "Le travail lié n'a pas pu être chargé",
openWithName: "En cours avec {{name}}",
noOpenWork: "{{name}} n'a aucun travail en cours. Pour lui confier une intervention, ouvrez-la et touchez Attribuer.",
},
operational: {
tabsLabel: "Sections du contact",
tabs: {
overview: "Vue d’ensemble",
assets: "Actifs",
requests: "Demandes",
history: "Historique",
},
sharedAssetsTitle: "Actifs partagés",
sharedAssetsEmpty: "Aucun élément partagé pour l'instant. Partagez un actif pour permettre à ce contact de demander des inspections ou de proposer des interventions.",
requestsTitle: "Demandes",
requestsEmpty: "Aucune demande de ce contact pour l'instant.",
relatedWorkTitle: "Travaux connexes",
relatedWorkEmpty: "Aucune intervention ou inspection associée pour l'instant.",
notesTitle: "Notes",
notesEmpty: "Aucune note sur ce contact.",
assetLinksTitle: "Liens vers les actifs",
assetLinksHelper: "Liens au niveau de la fiche (différents du partage d'espace de travail).",
assetFallback: "Actif",
jobFallback: "Intervention",
workspaceAccess: "Accès à l'espace de travail",
permissionJobs: "Interventions",
permissionInspections: "Inspections",
permissionDocuments: "Documents",
scheduleProposedAndScheduled: "Proposé : {{proposed}} · Planifié : {{scheduled}}",
scheduleScheduled: "Programmé {{scheduled}}",
scheduleProposed: "Proposé : {{proposed}}",
statusPrefix: "Statut {{status}}",
openRequestCount_one: "{{count}} demande ouverte",
openRequestCount_other: "{{count}} demandes ouvertes",
openAssetA11y: "Ouvrir l'actif {{name}}",
requestA11y: "Demande {{title}}",
jobA11y: "Intervention {{label}}",
inspectionA11y: "Inspection {{title}}",
shareAsset: "Partager l’actif",
shareAssetA11y: "Choisissez un actif à partager",
allRequests: "Toutes les demandes",
allRequestsA11y: "Voir toutes les demandes",
email: "E-mail",
emailA11y: "Envoyer un e-mail au contact",
invite: "Inviter",
inApp: "Dans l'application",
inviteA11y: "Inviter un contact",
shareContact: "Partager le contact",
shareContactA11y: "Partager le contact avec l'équipe",
openRequestCount_many: "{{count}} demandes ouvertes",
},
linkCard: {
unlinkA11y: "Dissocier le contact",
otherRole: "Autre",
contactFallback: "Contact",
},
inviteLanding: {
  acceptFailed: "Impossible d'accepter l'invitation. Réessayez ou demandez-en une nouvelle à la personne qui l'a envoyée.",
  acceptFailedTitle: "Impossible d'accepter l'invitation",
  accepted: "C'est fait. Tout ce qui est partagé avec vous apparaît dans Accueil.",
  expired: "Cette invitation a expiré. Demandez-en une nouvelle à la personne qui vous l'a envoyée.",
  desc: "{{name}}, vous avez été invité(e) sur AssetWRX. Connectez-vous pour voir ce qui a été partagé avec vous.",
},
};